import { ConductDeviceModel } from './coduct-device.model';

/**
 * Inicialización de la clase ConductRequestBodyModel, modelo para los request al servicio conducts ms
 *
 * *Set ConductRequestBodyModel class, model for requests to conducts ms*
 *
 * @access public
 * @type {class}
 */
export class ConductRequestBodyModel {
  /**
   *  Dirección ip
   *
   * *ip address*
   *
   * @type {string} ip
   */
  ip: string;

  /**
   *  Id de proyecto a nivel de Biocatch
   *
   * *Project id on Biocatch*
   *
   * @type {string} project_id
   */
  project_id: string;

  /**
   *  Operación a ejecutar en Biocatch
   *
   * *Operation to be executed on Biocatch*
   *
   * @type {string} operation_target
   */
  operation_target: string;

  /**
   *  Tipo de flujo (AO, ATO)
   *
   * *Flow type (AO, ATO)*
   *
   * @type {string} method_description
   */
  method_description: string;

  /**
   *  Identificador úniico del cliente
   *
   * *Client unique identifier*
   *
   * @type {string} ppid
   */
  ppid: string;

  /**
   *  Identificador úniico del cliente
   *
   * *Client unique identifier*
   *
   * @type {string} solicitation_type
   */
  solicitation_type: string;

  /**
   *  Valor definido por usuario funcional
   *
   * *Solicitatyon type defined by functional user*
   *
   * @type {string} solicitation_type
   */
  brand: string;

  /**
   *  Tipo de aplicación (APP, WEB)
   *
   * *Application type (APP, WEB)*
   *
   * @type {string} application_type
   */
  application_type: string;

  /**
   *  useragent
   *
   * *useragent*
   *
   * @type {string} application_agent
   */
  application_agent: string;

  /**
   *  Tipo de usuario
   *
   * *User type*
   *
   * @type {string} user_type
   */
  user_type: string;

  /**
   *  Modelo y estatus del equipo utilizado
   *
   * *Device model and status*
   *
   * @type {ConductDeviceModel} device
   */
  device: ConductDeviceModel;

  /**
   *  Estatus de bloqueo del equipo
   *
   * *Device locked status*
   *
   * @type {string} flag_locked
   */
  flag_locked: string;

  /**
   *  Estado de la sesión
   *
   * *Session status*
   *
   * @type {string} flag_session_id
   */
  flag_session_id: string;

  /**
   *  Método de autenticación utilizado por el usuario
   *
   * *Authentication methos used by user*
   *
   * @type {string} authMethodUsed
   */
  authMethodUsed?: string;

  /**
   *  Valor definido por usuario funcional
   *
   * *Value defined by functional user*
   *
   * @type {string} applicationID
   */
  applicationId?: string;

  /**
   *  Descripción de la ocupación del usuario
   *
   * *User job description*
   *
   * @type {string} jobDescription
   */
  jobDescription?: string;

  /**
   *  Estado civil del usuario
   *
   * *User's marital status*
   *
   * @type {string} maritalStatus
   */
  maritalStatus?: string;

  /**
   *  Estado civil del usuario
   *
   * *User's marital status*
   *
   * @type {string} maritalStatus
   */
  numOfFailedAuth?: string;

  /**
   *  Rango de edad del usuario
   *
   * *User's age range*
   *
   * @type {string} yob
   */
  yob?: string;

  /**
   *  Año de nacimiento del usuario
   *
   * *User's year of birth*
   *
   * @type {string} yearOfBirth
   */
  yearOfBirth?: string;

  /**
   *  Email ingresado por el usuario
   *
   * *User's email*
   *
   * @type {string} email
   */
  email?: string;

  /**
   *  Activity Name definido por el usuario funcional
   *
   * *Activity Name defined by functional user*
   *
   * @type {string} activityName
   */
  activityName?: string;

  /** nit del aliado */
  payeeAccountType?: string;

  constructor(bodyFields: any, operationTarget: string, activity: string, brand: string, ppid: string,
              solution: string, deviceModel: string, ip?: string) {
    this.ip = ip ? ip : '127.0.0.1';
    this.project_id = bodyFields.project_id;
    this.operation_target = operationTarget;
    this.method_description = solution;
    this.ppid = ppid;
    this.solicitation_type = activity;
    this.brand = brand;
    this.application_type = bodyFields.application_type;
    this.application_agent = window.navigator.userAgent;
    this.user_type = bodyFields.user_type;
    this.device = new ConductDeviceModel(deviceModel, bodyFields.flag_status);
    this.flag_locked = bodyFields.flag_locked;
    this.flag_session_id = bodyFields.flag_session_id;
    this.payeeAccountType = bodyFields.payeeAccountType;
  }
}
